var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"noticeWrap"},[_c('div',{staticClass:"notice"},[_c('img',{staticClass:"pic",attrs:{"src":_vm.noticeIcon,"alt":"公告"}}),_c('div',{staticClass:"txt marquee"},_vm._l((_vm.noticeCon),function(item){return _c('p',{domProps:{"innerHTML":_vm._s(item.title)}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }